import { render, staticRenderFns } from "./AppSwitchRow.vue?vue&type=template&id=7b345e8e&"
import script from "./AppSwitchRow.vue?vue&type=script&lang=js&"
export * from "./AppSwitchRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports